import { produce } from 'immer';

import { ShowImageInternalGallery } from '../../../actions/imageEditor/internal/showImageInternalGallery';
import { getImageEditorIdByBannerId } from '../../../service/ImageHelpers/ImageHelpers';
import { ImageEditorsState } from '../../../typings/state';

export function showImageInternalGallery(
    state: ImageEditorsState,
    action: ShowImageInternalGallery
): ImageEditorsState {
    const id = getImageEditorIdByBannerId(action.bannerId, action.resourceId);

    return produce(state, draft => {
        draft[id].imageGallery.isImageGalleryOpen = true;
        draft[id].imageGallery.selectedImageHashFromGallery = [];
    });
}
